import { render, staticRenderFns } from "./ReporteLaboratorio.vue?vue&type=template&id=c4762022"
import script from "./ReporteLaboratorio.vue?vue&type=script&lang=js"
export * from "./ReporteLaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports